import { render, staticRenderFns } from "./base.vue?vue&type=template&id=20fbe2d0&scoped=true&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&id=20fbe2d0&prod&scoped=true&lang=css&"
import style1 from "./base.vue?vue&type=style&index=1&id=20fbe2d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbe2d0",
  null
  
)

export default component.exports